<template>
  <!-- 图片 轮播 跟读 -->
  <div class="video-after-reading">
    <div class="video-list">
      <ul>
        <li
          @click="chooseImg(item, index)"
          v-for="(item, index) in showList"
          :key="index"
          :class="{'cur': item.audiovisual_title + item.audiovisual_url == choose}"
        >
          <p>{{ item.audiovisual_title }}</p>
        </li>
      </ul>
      <div class="arrow-list">
        <span @click="viewPrev" class="arrow icon-shangyiye"></span>
        <span @click="viewNext" class="arrow icon-xiayiye"></span>
        <!-- <span class="arrow icon-shangyiye"></span>
        <span class="arrow icon-xiayiye"></span>-->
      </div>
    </div>
    <div class="mp3-show">
      <p>{{ chooseTitle }}</p>
      <div class="play-mp3-box">
        <div class="mp3-content">
          <div class="audio-player-box">
            <img
              src="@/assets/images/studyCenter/audio-player/player-icon.png"
              class="player-icon"
              :class="{'rotate': plsyStatus=='play'}"
              alt
            />
            <div
              :class="{'img rotatePoseter':plsyStatus == 'paused', 'img':plsyStatus=='play'}"
            >
              <img :src="chooseUrl" alt />
            </div>
          </div>
        </div>
        <div class="mp3-controls">
          <img class="play-poster" :src="chooseUrl" alt />
          <audio preload muted id="micrioAudio" :src="chooseAudioUrl"></audio>

          <div class="player-desc">
            <span class="title">{{ chooseTitle }}</span>
            <div class="player-progress">
              <div
                class="inner-progress"
                :style="{'width': `${player.currentTime/player.duration*100}%`,'background-color': '#FFCC02' }"
              ></div>
            </div>
          </div>

          <div class="player-btns">
            <em class="controls-btn controls-btn-prev"></em>
            <em
              class="controls-btn controls-btn-play"
              :class="{'pause-icon':plsyStatus == 'paused', 'play-icon':plsyStatus=='play', 'replay-icon':plsyStatus=='ended'}"
            ></em>
            <em class="controls-btn controls-btn-next"></em>

            <em class="controls-btn controls-btn-voice"></em>
          </div>

          <!-- <em class="controls-btn pause-icon"></em> -->
        </div>
      </div>
      <!-- <MicroAnimation :videoUrl="chooseUrl"></MicroAnimation> -->
    </div>
  </div>
</template>
<script>
// import MicroAnimation from "@/components/StudyCenter/Review/MicroAnimation"; // 微动画
export default {
  name: "VideoAfterReading",
  props: ["list"],
  data() {
    return {
      curViewPage: 0,
      currentChooseIndex: 0,
      choose: "",
      chooseTitle: "",
      chooseUrl: "",
      showList: [],
      chooseAudioUrl: "",
      plsyStatus: "play",

      player: {
        duration: 0,
        currentTime: 0
      }
    };
  },
  components: {
    // MicroAnimation
  },
  watch: {
    list(n) {
      if (n.length > 0) {
        this.showList = this.list.slice(0, 8);
        this.choose = this.list[this.currentChooseIndex].audiovisual_title + this.list[this.currentChooseIndex].audiovisual_url;
        this.chooseTitle = this.list[this.currentChooseIndex].audiovisual_title
        this.chooseUrl = this.list[
          this.currentChooseIndex
        ].audiovisual_coverimg;
        this.chooseAudioUrl = this.list[
          this.currentChooseIndex
        ].audiovisual_url;
      }
    }
  },
  mounted() {
    let audio = document.getElementById("micrioAudio");
    // audio.addEventListener(
    //   "canplay",
    //   function() {
    //     audio.play();
    //   },
    //   false
    // );
    audio.addEventListener(
      "play",
      () => {
        this.plsyStatus = "paused";
      },
      false
    );
    audio.addEventListener(
      "pause",
      () => {
        this.plsyStatus = "play";
      },
      false
    );
    audio.addEventListener(
      "ended",
      () => {
        this.plsyStatus = 'ended'
      },
      false
    );

    audio.addEventListener(
      "loadedmetadata",
      e => {
        this.player.duration = e.target.duration;
      },
      false
    );
    audio.addEventListener(
      "timeupdate",
      e => {
        this.player.currentTime = e.target.currentTime;
      },
      false
    );

    let btn = document.querySelector(".controls-btn-play");
    btn.addEventListener(
      "click",
      function() {
        if (!audio.paused) {
          audio.pause();
        } else {
          audio.play();
        }
      },
      false
    );

    let next = document.querySelector(".controls-btn-next");
    let prev = document.querySelector(".controls-btn-prev");

    next.addEventListener(
      "click",
      () => {
        if (this.currentChooseIndex < this.list.length) {
          ++this.currentChooseIndex;
          this.chooseImg(
            this.list[this.currentChooseIndex],
            this.currentChooseIndex
          );
        }
      },
      false
    );
    prev.addEventListener(
      "click",
      () => {
        if (this.currentChooseIndex > 0) {
          --this.currentChooseIndex;
          this.chooseImg(
            this.list[this.currentChooseIndex],
            this.currentChooseIndex
          );
        }
      },
      false
    );
  },
  methods: {
    chooseImg(v, index) {
      if (v.audiovisual_title != this.choose) {
        this.plsyStatus = "play";
        this.choose = v.audiovisual_title + v.audiovisual_url;
        this.chooseTitle = v.audiovisual_title
        this.chooseUrl = v.audiovisual_coverimg;
        this.chooseAudioUrl = v.audiovisual_url;
        this.currentChooseIndex = index;
      }
    },
    viewNext() {
      let index = parseInt(this.list.length / 8);
      let left = this.list.length % 8;
      if (index > this.curViewPage + 1) {
        this.choose = 0;
        this.curViewPage++;
        this.showList = this.list.slice(
          this.curViewPage * 8,
          this.curViewPage * 8 + 8
        );
      } else if (index == this.curViewPage + 1 && left > 0) {
        this.curViewPage++;
        this.choose = 0;
        this.showList = this.list.slice(
          this.curViewPage * 8,
          this.curViewPage * 8 + left
        );
      }
    },
    viewPrev() {
      let index = parseInt(this.list.length / 8);
      let left = this.list.length % 8;
      if (0 < this.curViewPage) {
        this.curViewPage--;
        this.choose = 0;
        this.showList = this.list.slice(
          this.curViewPage * 4,
          this.curViewPage * 4 + 4
        );
      }
    }
  },
  created() {}
};
</script>